const data1 = {
	activityData: {
		// 社区累计活动量
		studyNum: 23,
		communityNum: 15,
		activityNum: 28,
		serviceNum: 300
	},
	groupData: {
		//党组织基本架构
		socailNum: 5,
		zhibuNum: 10,
		xiaozuNum: 20,
		dangyuanNum: 25
	},
	inoutData: [
		//居民进出数据
		{
			name: "徐正艳",
			label: "东门",
			time: "2020-04-22 12:30:45",
			color: "#FF2700"
		},
		{
			name: "郑顺芳",
			label: "西门",
			time: "2020-04-25 15:38:22",
			color: "#FFE400"
		}
	],
	weatherData: {
		// 气候数据
		wind: '3-4级',
		PMnum: '130ug',
		rank: '1',
		min: 20,
		max: 45,
		wendu: '24℃ 晴转多云'
	},
	caseData: '038395',
	caseNumData: {
		caseNum: 7123,
		finishPer: 80,
		finishTime: 32
	},
	caseArr: [{
			name: "徐正艳",
			label: "家具乱堆放",
			time: "04-22",
			color: "#FF2700"
		},
		{
			name: "郑顺芳",
			label: "发现小区有问题",
			time: "04-22",
			color: "#FFE400"
		}
	],
	specialPeople: {
		jiaoNum: 30,
		an: 35,
		xing: 32,
		du: 80,
		fang: 132,
		zhao: 20
	},
	contraArr: [{
			name: "徐正艳",
			label: "家具乱堆放",
			time: "04-22",
			color: "#FF2700"
		},
		{
			name: "郑顺芳",
			label: "发现小区有问题",
			time: "04-22",
			color: "#FFE400"
		}
	],
}
const data2 = {
	activityData: {
		// 社区累计活动量
		studyNum: 80,
		communityNum: 105,
		activityNum: 64,
		serviceNum: 237
	},
	groupData: {
		//党组织基本架构
		socailNum: 9,
		zhibuNum: 30,
		xiaozuNum: 50,
		dangyuanNum: 76
	},
	inoutData: [
		//居民进出数据
		{
			name: "徐正",
			label: "A门",
			time: "04-22",
			color: "#FF2700"
		},
		{
			name: "郑芳",
			label: "B门",
			time: "04-22",
			color: "#FFE400"
		}
	],
	weatherData: {
		// 气候数据
		wind: '1-2级',
		PMnum: '80ug',
		rank: '4',
		min: 10,
		max: 32,
		wendu: '28℃ 晴'
	},
	caseData: '157380',
	caseNumData: {
		caseNum: 385,
		finishPer: 35,
		finishTime: 96
	},
	caseArr: [{
			name: "正熊",
			label: "家具乱堆放",
			time: "04-22",
			color: "#FF2700"
		},
		{
			name: "郑顺",
			label: "发现小区有问题",
			time: "04-22",
			color: "#FFE400"
		}
	],
	specialPeople: {
		jiaoNum: 42,
		an: 65,
		xing: 38,
		du: 89,
		fang: 43,
		zhao: 60
	},
	contraArr: [{
			name: "徐正艳",
			label: "家具乱堆放",
			time: "04-22",
			color: "#FF2700"
		},
		{
			name: "郑顺芳",
			label: "发现小区有问题",
			time: "04-22",
			color: "#FFE400"
		}
	],
}

export default {
	dataArr: [data1, data2]
}